import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PlanoContasEmpresaEditarRoutingModule } from './plano-contas-empresa-editar-routing.module';
import { PlanoContasEmpresaEditarComponent } from './plano-contas-empresa-editar.component';
import { FormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { DividerModule } from 'primeng/divider';
import { MessagesModule } from 'primeng/messages';
import { DropdownModule } from 'primeng/dropdown';
import { InputSwitchModule } from 'primeng/inputswitch';
import { ProgressSpinnerModule } from 'primeng/progressspinner';


@NgModule({
  declarations: [
    PlanoContasEmpresaEditarComponent
  ],
  imports: [
    CommonModule,
    PlanoContasEmpresaEditarRoutingModule,
    FormsModule,
    InputTextModule,
    ButtonModule,
    DividerModule,
    MessagesModule,
    DropdownModule,
    InputSwitchModule,
    ProgressSpinnerModule
  ]
})
export class PlanoContasEmpresaEditarModule { }
